import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import { useBusinessSettings } from '../hooks/useBusinessSettings';
import MessageCenterShiftsPage from '../pages/message-center/MessageCenterShiftsPage';
import ShiftDetailsPage from '../pages/message-center/ShiftDetailsPage';
import ShiftTypesPage from '../pages/message-center/ShiftTypesPage';
import CommissionListPage from '../pages/message-center/CommissionListPage';
import CommissionDetailsPage from '../pages/message-center/CommissionDetailsPage';
import StaffCommissionPage from '../pages/message-center/StaffCommissionPage';
import ShiftLeaderCommissionPage from '../pages/message-center/ShiftLeaderCommissionPage';

const MessageCenterRoutes = () => {
  const { settings, isLoading } = useBusinessSettings('messageCenter');

  if (isLoading) return null;
  if (!settings.enabled) return <Navigate to="/dashboard" replace />;

  return (
    <Routes>
      <Route
        path="shifts"
        element={
          <PermissionRoute requiredPermission="view_message_center_shifts">
            <MessageCenterShiftsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="shifts/:id"
        element={
          <PermissionRoute requiredPermission="view_message_center_shifts">
            <ShiftDetailsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="shift-types"
        element={
          <PermissionRoute requiredPermission="manage_message_center_shift_types">
            <ShiftTypesPage />
          </PermissionRoute>
        }
      />
      <Route
        path="commission"
        element={
          <PermissionRoute requiredPermission="view_message_center_commission">
            <CommissionListPage />
          </PermissionRoute>
        }
      />
      <Route
        path="commission/:id"
        element={
          <PermissionRoute requiredPermission="view_message_center_commission">
            <CommissionDetailsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="staff-commission"
        element={
          <PermissionRoute requiredPermission="view_message_center_commission">
            <StaffCommissionPage />
          </PermissionRoute>
        }
      />
      <Route
        path="shift-leader-commission"
        element={
          <PermissionRoute requiredPermission="view_message_center_shift_leader_commission">
            <ShiftLeaderCommissionPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default MessageCenterRoutes;
